import { isObject } from 'lodash';

export const getQueryString = (obj, prefix?) => {
  if (!obj) {
    return;
  }

  const strings = [];

  Object.keys(obj).forEach((key) => {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      const k = prefix ? `${prefix}[${key}]` : key;
      const v = obj[key];

      strings.push(
        v !== null && isObject(v)
          ? getQueryString(v, k)
          : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
      );
    }
  });

  return strings.join('&');
};
